<template>
    <div ref="companyClientLayout" class="company-home">
        <company-header class="header-box"></company-header>
        <router-view id="container-box" class="container-box"></router-view>
    </div>
</template>

<script>
import CompanyHeader from '../components/CompanyHeader.vue'

export default {
    name: 'companyHome',
    components: {
        CompanyHeader,
    },
    data() {
        return {
            headerHeight: 0,
            bgcImage: {
                default: require('@/assets/company-home-bg.webp'),
                rights: require('@/assets/bgc-right.png'),
                RecordsOfConsumption: require('@/assets/company-back/Consumptionback.png'),
                inviteScanCode: require('@/assets/company-back/Consumptionback.png'),
            },
        }
    },
    watch: {
        '$route.name': {
            immediate: true,
            handler(routeName) {
                const imagePath = this.bgcImage[routeName] || this.bgcImage.default
                this.$nextTick(() => {
                    const element = this.$refs.companyClientLayout
                    if (element) {
                        element.style.background = `url(${imagePath}) no-repeat  100% 100%`
                        element.style.backgroundSize = 'cover'
                    }

                    this.calculateHeaderHeight()
                })
            },
        },
    },
    mounted() {
        this.calculateHeaderHeight()
    },
    methods: {
        calculateHeaderHeight() {
            const headerBox = document.querySelector('.header-box')
            const content = document.getElementById('container-box')
            if (headerBox && content) {
                content.style.minHeight = `calc(100vh - ${headerBox.offsetHeight}px)`
            }
        },
    },
    beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
.company-home {
    min-height: 100%;
    position: relative;
}

.header-box {
    height: auto;
}

// router-view的高度将自动占据剩余空间
//router-view {
//    height: calc(100% - #{v-bind(headerHeight)}px);
//    display: block;
//}
</style>
